import { useCallback } from 'react'

import { useProductFlags } from '@/screens/Product/hooks/use-product-flags'
import { useProduct } from '@/screens/Product/hooks/useProduct'
import { useProductBonus } from '@/screens/Product/hooks/useProductBonus'

import { AuthTrigger } from '../product-price-widget/AuthTrigger/AuthTrigger'

import cl from './auth-trigger-block.module.scss'

export const AuthTriggerBlock = () => {
	const { productIsInStock } = useProductFlags()
	const { product } = useProduct()
	const { refetch } = useProductBonus(product.ID)

	const getPersonalData = useCallback(async () => {
		if (!productIsInStock || !product?.PRICE?.VALUE) return
		await refetch()
	}, [refetch, productIsInStock, product?.PRICE?.VALUE])

	return (
		<div className={cl.authTriggerWrapper}>
			<AuthTrigger onSuccess={getPersonalData} />
		</div>
	)
}
